module.exports = __webpack_public_path__ + "img/be6742d.jpg";